import {useCallback} from 'react';
import {useMutation} from 'react-query';
import {removeVk} from '../backendApi';
import {useViewKey} from '../contexts/ViewKeyProvider.client';

export default function RemoveViewKeyButton() {
  const {viewKey} = useViewKey();
  const {mutate, isLoading} = useMutation('deleteViewKey', () => removeVk(), {
    onSuccess: () => {
      window.location.reload();
    },
  });

  const handleClick = useCallback(() => mutate(), [mutate]);

  if (!viewKey) {
    return;
  }

  return (
    <button
      onClick={handleClick}
      disabled={isLoading}
      className="button remove-vk-button"
    >
      Disable Preview
    </button>
  );
}
